(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    (function () {
        const switcher = document.getElementById('collection-view-switcher');
        if (!switcher) return;

        const toggles = switcher.querySelectorAll('.view-toggle');

        function swapProductCardViewSlides() {
          document.querySelectorAll('product-card slideshow-slides').forEach((el) => {
            const component = el.closest('slideshow-component');
            const [primarySlide, alternateSlide] = component?.slides || [];
            if (!primarySlide || !alternateSlide) return;

            el.insertBefore(alternateSlide, primarySlide);
            requestAnimationFrame(() => {
              component?.select(0, undefined, { animate: false });
            });
          });
        }

        toggles.forEach((toggle) => {
          toggle.addEventListener('click', () => {
            if (toggle.classList.contains('active')) return;
            toggles.forEach((t) => t.classList.toggle('active', t === toggle));
            swapProductCardViewSlides();
          });
        });
      })();
  } catch(e) { console.error(e); }
})();

})();
